module.exports = __webpack_public_path__ + "img/relax.b407ab82.png";